<template>
    <el-container class="detail-page">
        <el-header>
            <div>
                {{$t('companyInfo.title')}}
            </div>
            <div>
                <el-button @click.native.prevent="updateCompanyInfo" type="success"
                           :disabled="!companyDataLoaded || loading || buttonDisabledStatus || pageHaveChange !== 1">{{$t('common.save')}}
                </el-button>
            </div>
        </el-header>

        <el-main>

            <div v-if="loading && !companyDataLoaded" class="company-info-initial-loading" v-loading="true"></div>
            <el-alert v-else-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <div v-else-if="companyDataLoaded">
                <el-form class="settings-detail-form" label-position="left" label-width="160px" :model="companyInfo" v-loading="loading">
                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>{{$t('companyInfo.details')}}</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item :label="$t('companyInfo.businessName')">
                                    <el-input :placeholder="$t('companyInfo.businessNamePlaceholder')" v-model="companyInfo.companyName"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.name')">
                                    <el-input placeholder="" v-model="companyInfo.contactName"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.phone')">
                                    <el-input placeholder="" v-model="companyInfo.phone"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.email')">
                                    <el-input placeholder="" v-model="companyInfo.companyEmail"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.businessNumber')">
                                    <el-input placeholder="" v-model="companyInfo.businessNumber"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.taxNo')">
                                    <el-input placeholder="" v-model="userSetting.taxRegNValue"></el-input>
                                </el-form-item>
                                <el-divider></el-divider>

                                <div class="company-custom-field-row" v-for="(value,index) in userFieldList" :key="'user-field-' + index">
                                    <el-input style="width: 20%" type="text" v-model="value.fieldKey"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="value.fieldValue"></el-input>
                                    <el-button style="color: red;margin-left: 2%" type="text" @click="deleteUserField(index)" circle>{{$t('companyInfo.deleteField')}}</el-button>
                                </div>
                                <div style="margin-top: 12px;margin-left: 1%">
                                    <el-button type="primary" @click="addNewField" circle icon="el-icon-plus">
                                    </el-button>
                                    <el-button type="text" @click="addNewField">
                                        {{$t('companyInfo.addNewField')}}
                                    </el-button>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <div class="company-info-column">
                        <el-row>
                            <el-col :span="24">
                                <el-card>
                                    <el-row>
                                        <el-col :span="16" class="biaoti">
                                            <div class="grid-content bg-purple">
                                                <span>{{$t('companyInfo.address')}}</span>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <el-divider></el-divider>
                                    <el-form-item :label="$t('companyInfo.line1')">
                                        <el-input placeholder="" v-model="companyInfo.addressOne"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('companyInfo.line2')">
                                        <el-input placeholder="" v-model="companyInfo.addressTwo"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('companyInfo.line3')">
                                        <el-input placeholder="" v-model="companyInfo.addressThree"></el-input>
                                    </el-form-item>
                                </el-card>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <el-card>
                                    <el-row>
                                        <el-col :span="16" class="biaoti">
                                            <div class="grid-content bg-purple">
                                                <span>{{$t('companyInfo.terms')}}</span>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <el-divider></el-divider>
                                    <el-form-item :label="$t('companyInfo.termsLabel')">
                                        <el-select class="test111" v-model="userSetting.term" placeholder="">
                                            <el-option :label="$t('companyInfo.termSameDay')" value="0"></el-option>
                                            <el-option :label="$t('companyInfo.term7Days')" value="7"></el-option>
                                            <el-option :label="$t('companyInfo.term14Days')" value="14"></el-option>
                                            <el-option :label="$t('companyInfo.term21Days')" value="21"></el-option>
                                            <el-option :label="$t('companyInfo.term30Days')" value="30"></el-option>
                                            <el-option :label="$t('companyInfo.term45Days')" value="45"></el-option>
                                            <el-option :label="$t('companyInfo.term60Days')" value="60"></el-option>
                                            <el-option :label="$t('companyInfo.term90Days')" value="90"></el-option>
                                            <el-option :label="$t('companyInfo.term180Days')" value="180"></el-option>
                                            <el-option :label="$t('companyInfo.term365Days')" value="365"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>

                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>{{$t('companyInfo.currency')}}</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <el-form-item :label="$t('companyInfo.currencyLabel')">
                                    <el-select v-model="userSetting.currencyName" placeholder="" @change="changeCurrency">
                                        <el-option
                                                v-for=" (value, key) in currencySymbolMap"
                                                :key="key"
                                                :label="key === 'Other' ? 'Other (Customize)' : key+' ('+value+')'"
                                                :value=key></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.symbol')">
                                    <el-input placeholder="" :readonly="symbolReadonly" :disabled="symbolReadonly" v-model="userSetting.currency"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.placement')">
                                    <el-radio-group v-model="userSetting.currencyPlacementAtBefore" size="small">
                                        <el-radio-button :label="1">{{$t('companyInfo.before')}}</el-radio-button>
                                        <el-radio-button :label="0">{{$t('companyInfo.after')}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.thousandSymbol')">
                                    <el-input placeholder="" v-model="userSetting.currencyThousandSymbol"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.decimalSymbol')">
                                    <el-input placeholder="" v-model="userSetting.currencyDeciamlSymbol"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('companyInfo.decimalPlaces')">
                                    <el-radio-group v-model="userSetting.currencyDecimalPlaces">
                                        <el-radio-button :label="0"></el-radio-button>
                                        <el-radio-button :label="1"></el-radio-button>
                                        <el-radio-button :label="2"></el-radio-button>
                                        <el-radio-button :label="3"></el-radio-button>
                                        <el-radio-button :label="4"></el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-divider></el-divider>
                                <el-form-item :label="$t('companyInfo.example')">
                                    <span>{{ xiaoshudianfenge1(1000.00000,userSetting)}}</span>
                                </el-form-item>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>{{$t('companyInfo.paymentInfo')}}</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>

                                <el-form-item :label="$t('companyInfo.displayOnInvoices')">
                                    <el-switch v-model="companyInfo.showPaymentInfoOnPDF" :active-value=1 :inactive-value=0></el-switch>
                                </el-form-item>

                                <div class="company-payment-row">
                                    <el-input style="width: 20%" type="text" :disabled="true" :placeholder="$t('companyInfo.titlePlaceholder')"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="companyInfo.paymentInstructionsLabel"></el-input>
                                </div>

                                <div class="company-payment-row" style="margin-top: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.paypalAddressTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.paypalEmail"></el-input>
                                </div>
                                <div class="company-payment-row" style="margin-top: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.makeChequesPaybleToTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.businessName"></el-input>
                                </div>
                                <div class="company-payment-row" style="margin-top: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.bankTransferTitle"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="userSetting.bandInfo"></el-input>
                                </div>
                                <div class="company-payment-row" style="margin-top: 15px;margin-bottom: 15px">
                                    <el-input style="width: 20%" type="text" v-model="companyInfo.paymentInfoOtherTitle"></el-input>
                                    <el-input style="width: 60%" type="textarea" :autosize="{minRows: 3}"
                                              v-model="userSetting.additionalPaymentInfo"></el-input>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-card>
                                <el-row>
                                    <el-col :span="16" class="biaoti">
                                        <div class="grid-content bg-purple">
                                            <span>{{$t('companyInfo.jobDetails')}}</span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-divider></el-divider>
                                <div class="company-job-field-row" v-for="(value,index) in jobDetailsListList" :key="'job-detail-' + index">
                                    <el-input style="width: 20%" type="text" v-model="value.fieldKey"></el-input>
                                    <el-input style="width: 60%" type="text" v-model="value.fieldValue"></el-input>
                                    <el-button style="color: red;margin-left: 2%" type="text" @click="deletejobDetail(index)" circle>{{$t('companyInfo.deleteJobDetail')}}</el-button>
                                </div>
                                <div style="margin-top: 12px;margin-left: 1%">
                                    <el-button type="primary" @click="addJobDetailField" circle icon="el-icon-plus">
                                    </el-button>
                                    <el-button type="text" @click="addJobDetailField">
                                        {{$t('companyInfo.addNewJobField')}}
                                    </el-button>
                                </div>

                            </el-card>
                        </el-col>
                    </el-row>


                </el-form>

            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {timest, validateEmailCanKong} from '@/utils/validate'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {replaceStoredCompany, replaceStoredSetting, syncCompanySelection} from '@/utils/company'

    export default {
        methods: {
            xiaoshudianfenge1: xiaoshudianfenge,
            parseStoredFields(serialized) {
                if (serialized === '') {
                    return [];
                }
                return serialized.split('&&').map(pair => {
                    const separatorIndex = pair.indexOf(':');
                    if (separatorIndex < 0) {
                        return {
                            fieldKey: pair,
                            fieldValue: ''
                        };
                    }
                    return {
                        fieldKey: pair.substring(0, separatorIndex),
                        fieldValue: pair.substring(separatorIndex + 1)
                    };
                });
            },
            showValidationError(message) {
                this.$message({
                    type: 'error',
                    message: message,
                    duration: 4000
                });
            },
            settingsSnapshot() {
                const companyFields = [
                    'companyName', 'contactName', 'phone', 'companyEmail', 'businessNumber',
                    'addressOne', 'addressTwo', 'addressThree', 'showPaymentInfoOnPDF',
                    'paymentInstructionsLabel', 'paypalAddressTitle', 'makeChequesPaybleToTitle',
                    'bankTransferTitle', 'paymentInfoOtherTitle'
                ];
                const settingFields = [
                    'term', 'taxRegNValue', 'paypalEmail', 'businessName', 'bandInfo',
                    'additionalPaymentInfo', 'currencyPlacementAtBefore', 'currencyThousandSymbol',
                    'currencyDeciamlSymbol', 'currencyDecimalPlaces', 'currency', 'currencyName'
                ];
                const company = {};
                const setting = {};
                companyFields.forEach(field => {
                    company[field] = this.companyInfo[field];
                });
                settingFields.forEach(field => {
                    setting[field] = this.userSetting[field];
                });
                return JSON.stringify({
                    company: company,
                    setting: setting,
                    userFields: this.userFieldList,
                    jobDetails: this.jobDetailsListList
                });
            },
            updateDirtyState() {
                this.pageHaveChange = this.initialSettingsSnapshot !== ''
                    && this.settingsSnapshot() !== this.initialSettingsSnapshot ? 1 : 0;
            },
            serializeFields(fieldList) {
                const serializedList = [];
                for (let i = 0; i < fieldList.length; i++) {
                    const fieldKey = fieldList[i].fieldKey.trim();
                    const fieldValue = fieldList[i].fieldValue.trim();
                    if (fieldKey === '' && fieldValue === '') {
                        continue;
                    }
                    serializedList.push(fieldKey + ':' + fieldValue);
                }
                return serializedList.join('&&');
            },
            async queryUserSetting() {
                this.loading = true;
                this.companyDataLoaded = false;
                this.loadError = '';
                try {
                    const response = await this.$axios.post('query_setting_and_company', {
                        params: {}
                    });
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.userSetting = selectedData.setting;
                    this.userSetting.term = this.userSetting.term == null
                        ? '' : String(this.userSetting.term);
                    this.symbolReadonly = this.userSetting.currencyName !== "Other";
                    this.companyInfo = selectedData.company;
                    this.userFieldList = this.parseStoredFields(selectedData.company.otherFields);
                    this.jobDetailsListList = this.parseStoredFields(selectedData.company.jobDetails);
                    if (!this.userFieldList.some(field => field.fieldKey === 'Website')) {
                        this.userFieldList.push({fieldKey: "Website", fieldValue: ""});
                    }
                    this.initialSettingsSnapshot = this.settingsSnapshot();
                    this.pageHaveChange = 0;
                    this.companyDataLoaded = true;
                    this.buttonDisabledStatus = false;

                    this.$watch('userSetting', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('companyInfo', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('userFieldList', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('jobDetailsListList', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                } catch {
                    this.loadError = this.$t('common.loadFailed');
                } finally {
                    this.loading = false;
                }
            },
            updateCompanyInfo(flag, next) {
                if (!this.companyDataLoaded || this.loading || this.buttonDisabledStatus || this.pageHaveChange !== 1) {
                    return;
                }
                const companyName = String(this.companyInfo.companyName == null ? '' : this.companyInfo.companyName).trim();
                if (!validateEmailCanKong(this.companyInfo.companyEmail)) {
                    this.showValidationError(this.$t('common.validEmail'));
                    return;
                }
                this.companyInfo.companyName = companyName;
                const userFieldListString = this.serializeFields(this.userFieldList);
                const jobDetailString = this.serializeFields(this.jobDetailsListList);
                let self = this;
                this.loading = true;
                self.buttonDisabledStatus = true;

                let settingInfo = {
                    term: this.userSetting.term,
                    taxRegNValue: this.userSetting.taxRegNValue,
                    paypalEmail: this.userSetting.paypalEmail,
                    businessName: this.userSetting.businessName,
                    bandInfo: this.userSetting.bandInfo,
                    additionalPaymentInfo: this.userSetting.additionalPaymentInfo,
                    currencyPlacementAtBefore: this.userSetting.currencyPlacementAtBefore,
                    currencyThousandSymbol: this.userSetting.currencyThousandSymbol,
                    currencyDeciamlSymbol: this.userSetting.currencyDeciamlSymbol,
                    currencyDecimalPlaces: this.userSetting.currencyDecimalPlaces,
                    currency: this.userSetting.currency,
                    currencyCountry: this.currencyJianChenMap[this.userSetting.currencyName],
                    currencyName: this.userSetting.currencyName,
                    innerUUID: this.userSetting.innerUUID,
                    companyUUID: this.userSetting.companyUUID,
                    accessDate: timest()
                };
                let companyInfo = {
                    companyName: this.companyInfo.companyName,
                    contactName: this.companyInfo.contactName,
                    phone: this.companyInfo.phone,
                    companyEmail: this.companyInfo.companyEmail,
                    businessNumber: this.companyInfo.businessNumber,
                    term: this.companyInfo.term,
                    addressOne: this.companyInfo.addressOne,
                    addressTwo: this.companyInfo.addressTwo,
                    addressThree: this.companyInfo.addressThree,
                    showPaymentInfoOnPDF: this.companyInfo.showPaymentInfoOnPDF,
                    paypalAddressTitle: this.companyInfo.paypalAddressTitle,
                    makeChequesPaybleToTitle: this.companyInfo.makeChequesPaybleToTitle,
                    bankTransferTitle: this.companyInfo.bankTransferTitle,
                    paymentInfoOtherTitle: this.companyInfo.paymentInfoOtherTitle,
                    otherFields: userFieldListString,
                    jobDetails: jobDetailString,
                    innerUUID: this.companyInfo.innerUUID,
                    companyUUID: this.companyInfo.innerUUID,
                    paymentInstructionsLabel: this.companyInfo.paymentInstructionsLabel,
                    accessDate: timest()
                }
                this.$axios.post('update_setting_and_company', {
                    params: {"settingReq": settingInfo, "companyReq": companyInfo}

                }).then(response => {
                    this.loading = false;
                    self.buttonDisabledStatus = false;
                    if (response.data.errorCode === 0) {

                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.term = this.userSetting.term;
                        tempUserSetting.taxRegNValue = this.userSetting.taxRegNValue;
                        tempUserSetting.paypalEmail = this.userSetting.paypalEmail;
                        tempUserSetting.businessName = this.userSetting.businessName;
                        tempUserSetting.bandInfo = this.userSetting.bandInfo;
                        tempUserSetting.additionalPaymentInfo = this.userSetting.additionalPaymentInfo;
                        tempUserSetting.currencyPlacementAtBefore = this.userSetting.currencyPlacementAtBefore;
                        tempUserSetting.currencyThousandSymbol = this.userSetting.currencyThousandSymbol;
                        tempUserSetting.currencyDeciamlSymbol = this.userSetting.currencyDeciamlSymbol;
                        tempUserSetting.currencyDecimalPlaces = this.userSetting.currencyDecimalPlaces;
                        tempUserSetting.currency = this.userSetting.currency;
                        tempUserSetting.currencyCountry = this.currencyJianChenMap[this.userSetting.currencyName];
                        tempUserSetting.currencyName = this.userSetting.currencyName;
                        replaceStoredSetting(tempUserSetting);

                        let tempCompany = JSON.parse(localStorage.getItem('userCompany'));
                        tempCompany.companyName = this.companyInfo.companyName;
                        tempCompany.contactName = this.companyInfo.contactName;
                        tempCompany.phone = this.companyInfo.phone;
                        tempCompany.companyEmail = this.companyInfo.companyEmail;
                        tempCompany.businessNumber = this.companyInfo.businessNumber;
                        tempCompany.term = this.companyInfo.term;
                        tempCompany.addressOne = this.companyInfo.addressOne;
                        tempCompany.addressTwo = this.companyInfo.addressTwo;
                        tempCompany.addressThree = this.companyInfo.addressThree;
                        tempCompany.showPaymentInfoOnPDF = this.companyInfo.showPaymentInfoOnPDF;
                        tempCompany.paypalAddressTitle = this.companyInfo.paypalAddressTitle;
                        tempCompany.makeChequesPaybleToTitle = this.companyInfo.makeChequesPaybleToTitle;
                        tempCompany.bankTransferTitle = this.companyInfo.bankTransferTitle;
                        tempCompany.paymentInfoOtherTitle = this.companyInfo.paymentInfoOtherTitle;
                        tempCompany.paymentInstructionsLabel = this.companyInfo.paymentInstructionsLabel;
                        tempCompany.otherFields = userFieldListString;
                        tempCompany.jobDetails = jobDetailString;

                        replaceStoredCompany(tempCompany);

                        this.initialSettingsSnapshot = this.settingsSnapshot();
                        this.pageHaveChange = 0;
                        this.$message({
                            message: this.$t('common.updateSuccess'),
                            type: 'success',
                            duration: "2000"
                        });
                        if (flag === 100) {
                            next();
                        }
                    } else {
                        this.$message.error(this.$t('common.saveFailed'));
                    }
                }).catch(function () {
                    self.loading = false;
                    self.buttonDisabledStatus = false;
                    self.$message.error(self.$t('common.systemError'));
                })
            },
            changeCurrency: function () {
                this.userSetting.currency = this.currencySymbolMap[this.userSetting.currencyName];
                if (this.userSetting.currencyName === "Other") {
                    this.symbolReadonly = false;
                } else {
                    this.symbolReadonly = true;
                }
            },
            addNewField: function () {
                let newField = {
                    fieldKey: "",
                    fieldValue: ""
                };
                this.userFieldList.push(newField);
            },
            deleteUserField: function (index) {

                this.userFieldList.splice(index, 1);
            }
            ,
            addJobDetailField: function () {
                let newField = {
                    fieldKey: "",
                    fieldValue: ""
                };
                this.jobDetailsListList.push(newField);
            },
            deletejobDetail: function (index) {

                this.jobDetailsListList.splice(index, 1);
            }

        },
        data() {
            return {
                companyInfo: {},
                userSetting: {},
                buttonDisabledStatus: true,
                currencySymbolMap: {
                    "Albanian Lek": "Lek", "Argentine Peso": "$", "Australian Dollar": "$",
                    "Bahamian Dollar": "$", "Barbadian Dollar": "$", "Belize Dollar": "BZ$", "Bermudan Dollar": "$", "Bolivian Boliviano": "Bs", "Brazilian Real": "R$", "British Pound Sterling": "£",
                    "Chinese Yuan": "¥", "Canadian Dollar": "$", "Cayman Islands Dollar": "$", "Chilean Peso": "$",
                    "Colombian Peso": "$", "Costa Rican Colón": "₡", "Croatian Kuna": "kn", "Czech Republic Koruna": "Kč",
                    "Danish Krone": "kr", "Dominican Peso": "$",
                    "Egyptian Pound": "E£", "East Caribbean Dollar": "$", "Euro": "€",
                    "Guatemalan Quetzal": "Q", "Guyanaese Dollar": "$",
                    "Hong Kong Dollar": "HK$", "Honduran Lempira": "L", "Hungarian Forint": "Ft",
                    "Icelandic Króna": "kr", "Israeli New Shekel": "₪", "Indian Rupee": "Rs", "Indonesian Rupiah": "Rp",
                    "Japanese Yen": "¥", "Jamaican Dollar": "$",
                    "Kenyan Shilling": "KSh",
                    "Moroccan Dirham": "MAD", "Malaysian Ringgit": "RM", "Mexican Peso": "$",
                    "Nigerian Naira": "₦", "New Zealand Dollar": "$", "Nicaraguan Córdoba": "C$", "Norwegian Krone": "kr",
                    "Oman Rials": "OMR",
                    "Panamanian Balboa": "B/．", "Paraguayan Guarani": "Gs", "Peruvian Nuevo Sol": "S/．", "Polish Zloty": "zł", "Philippine Peso": "₱",
                    "Romanian Leu": "lei",
                    "Saudi Riyal": "SAR", "South Korean Won": "₩", "Singapore Dollar": "$", "South African Rand": "R", "Swedish Krona": "kr",
                    "Swiss Franc": "CHF",
                    "Thai Baht": "฿", "Turkish Lira": "TL",
                    "United Arab Emirates": "AED", "Uruguayan Peso": "$", "US Dollar": "$",
                    "Venezuelan Bolívar": "Bs．",
                    "Other": ""
                },
                currencyJianChenMap: {
                    "Albanian Lek": "ALL", "Argentine Peso": "ARS", "Australian Dollar": "AUD",
                    "Bahamian Dollar": "BSD", "Barbadian Dollar": "BBD", "Belize Dollar": "BZD", "Bermudan Dollar": "BMD", "Bolivian Boliviano": "BOB", "Brazilian Real": "BRL", "British Pound Sterling": "GBP",
                    "Chinese Yuan": "CNY", "Canadian Dollar": "CAD", "Cayman Islands Dollar": "KYD", "Chilean Peso": "CLP",
                    "Colombian Peso": "COP", "Costa Rican Colón": "CRC", "Croatian Kuna": "HRK", "Czech Republic Koruna": "CZK",
                    "Danish Krone": "DKK", "Dominican Peso": "DOP",
                    "Egyptian Pound": "EGP", "East Caribbean Dollar": "XCD", "Euro": "EUR",
                    "Guatemalan Quetzal": "GTQ", "Guyanaese Dollar": "GYD",
                    "Hong Kong Dollar": "HKD", "Honduran Lempira": "HNL", "Hungarian Forint": "HUF",
                    "Icelandic Króna": "ISK", "Israeli New Shekel": "ILS", "Indian Rupee": "INR", "Indonesian Rupiah": "IDR",
                    "Jamaican Dollar": "JMD", "Japanese Yen": "JPY",
                    "Kenyan Shilling": "KES",
                    "Moroccan Dirham": "MAD", "Malaysian Ringgit": "MYR", "Mexican Peso": "MXN",
                    "Nigerian Naira": "NGN", "New Zealand Dollar": "NZD", "Nicaraguan Córdoba": "NIO", "Norwegian Krone": "NOK",
                    "Oman Rials": "OMR",
                    "Panamanian Balboa": "PAB", "Paraguayan Guarani": "PYG", "Peruvian Nuevo Sol": "PEN", "Polish Zloty": "PLN", "Philippine Peso": "PHP",
                    "Romanian Leu": "RON",
                    "South Korean Won": "KRW", "Saudi Riyal": "SAR", "Singapore Dollar": "SGD", "South African Rand": "ZAR", "Swedish Krona": "SEK",
                    "Swiss Franc": "CHF",
                    "Thai Baht": "THB", "Turkish Lira": "TRY",
                    "United Arab Emirates": "AED", "Uruguayan Peso": "UYU", "US Dollar": "USD",
                    "Venezuelan Bolívar": "VEF",
                    "Other": "Other"
                },
                currency: "",
                symbolReadonly: true,
                userFieldList: [],
                jobDetailsListList: [],
                loading: true,
                companyDataLoaded: false,
                loadError: '',
                pageHaveChange: 0,
                initialSettingsSnapshot: ''
            }
        },
        mounted() {
            this.queryUserSetting();
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.pageHaveChange === 1) {
                next(false)
                this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.updateCompanyInfo(100, next);
                }).catch(function (action) {
                    if (action === 'cancel') {
                        next();
                    }
                });
            } else {
                next();
            }
        }
    }
</script>
<style scoped>
    .company-info-initial-loading {
        min-height: 240px;
    }

    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 600;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    /deep/ .el-input__inner {
        /*width: 60%;*/
        margin-left: 2%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    /deep/ .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        width: 15%;
        text-align: left;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxListform {
        margin-left: 10%;
        margin-top: 20px;
    }

    .el-select {
        display: block;
    }

    /deep/ .el-input__suffix {
        left: 0;
    }

    /deep/ .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .el-input {
        width: 60%;
    }

    .settings-detail-form >>> .el-form-item__label {
        position: relative;
        left: 1%;
        text-align: left;
    }

    /deep/ .el-input__suffix {
        text-align: right;
    }

    .settings-detail-form {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        align-items: start;
        gap: 24px;
    }

    .settings-detail-form > .el-row {
        min-width: 0;
    }

    .company-info-column {
        display: flex;
        flex-direction: column;
        gap: 24px;
        min-width: 0;
    }

    .settings-detail-form >>> .el-form-item .el-input {
        width: 100%;
    }

    .settings-detail-form >>> .el-form-item .el-input__inner {
        margin-left: 0;
    }

    @media (max-width: 1200px) {
        .settings-detail-form {
            grid-template-columns: minmax(0, 1fr);
        }
    }

    .company-custom-field-row,
    .company-job-field-row {
        display: flex;
    }

    .company-payment-row {
        display: flex;
    }

    .company-payment-row >>> .el-textarea__inner {
        margin-left: 2%;
    }

    @media (max-width: 640px) {
        /deep/ .el-header {
            height: 86px !important;
            padding: 28px 72px 20px 20px;
        }

        /deep/ .el-main {
            padding: 12px;
        }

        /deep/ .el-card__body {
            padding: 20px;
        }

        .settings-detail-form >>> .el-form-item {
            display: block;
        }

        .settings-detail-form >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            padding-right: 0;
            line-height: 24px;
        }

        .settings-detail-form >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        /deep/ .el-input,
        /deep/ .el-select {
            width: 100%;
        }

        /deep/ .el-input__inner {
            margin-left: 0;
        }

        .company-custom-field-row,
        .company-payment-row,
        .company-job-field-row {
            display: grid !important;
            grid-template-columns: minmax(0, 1fr);
            gap: 10px;
            margin-bottom: 16px;
        }

        .company-custom-field-row >>> .el-input,
        .company-payment-row >>> .el-input,
        .company-job-field-row >>> .el-input {
            width: 100% !important;
        }

        .company-payment-row >>> .el-textarea__inner {
            margin-left: 0;
        }

        .company-custom-field-row >>> .el-button,
        .company-job-field-row >>> .el-button {
            justify-self: start;
            margin-left: 0 !important;
        }

        /deep/ .el-radio-group {
            display: flex;
            flex-wrap: wrap;
        }
    }

</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
